export default {"src":"/_next/static/media/calendarThree_24.3cadf019.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};